import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { REQUEST_STATUS, RequestStatus } from "../../../shared/consts";
import { Suggestion } from "../types";

type SuggestionsTableProps = {
  wordSuggestionsStatus: RequestStatus;
  wordSuggestions: Suggestion[];
  inputValue: string;
  selectedSuggestionIndex: number | null;
  setSelectedSuggestionIndex: React.Dispatch<
    React.SetStateAction<number | null>
  >;
};

export const SuggestionsTable = ({
  wordSuggestionsStatus,
  wordSuggestions,
  inputValue,
  selectedSuggestionIndex,
  setSelectedSuggestionIndex,
}: SuggestionsTableProps) => {
  return (
    <Box sx={{ mt: 2 }}>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 300,
          minHeight: 300,
          border: "1px solid #ccc",
          boxShadow: "none",
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "40%" }}>
                <strong>Word</strong>
              </TableCell>
              <TableCell sx={{ width: "60%" }}>
                <strong>Tag</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {wordSuggestionsStatus === REQUEST_STATUS.FAILURE && (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  Error loading word suggestions, please try again later
                </TableCell>
              </TableRow>
            )}
            {wordSuggestionsStatus === REQUEST_STATUS.SUCCESS &&
              wordSuggestions.length === 0 && (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    No word suggestions found
                  </TableCell>
                </TableRow>
              )}
            {wordSuggestions.length > 0 &&
              inputValue.trim() &&
              wordSuggestions.map((suggestion, index) => (
                <TableRow
                  key={index}
                  hover
                  selected={selectedSuggestionIndex === index}
                  onClick={() => {
                    setSelectedSuggestionIndex(index);
                  }}
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell>{suggestion.fe_display}</TableCell>
                  <TableCell>{suggestion.tag}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
